(function () {
  function init(root) {
    if (root.dataset.ftcInit) return;
    root.dataset.ftcInit = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ftc-item]'));
    if (!items.length) return;

    function closeAll(except) {
      items.forEach(function (other) {
        if (other === except) return;
        other.classList.remove('is-open');
        var ob = other.querySelector('.ftc__q');
        if (ob) ob.setAttribute('aria-expanded', 'false');
        var op = other.querySelector('.ftc__a');
        if (op) op.style.maxHeight = '';
      });
    }

    function setOpenHeight(item) {
      var panel = item.querySelector('.ftc__a');
      var inner = item.querySelector('.ftc__a-inner');
      if (!panel || !inner) return;
      panel.style.maxHeight = inner.scrollHeight + 'px';
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.ftc__q');
      var panel = item.querySelector('.ftc__a');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        closeAll(item);
        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = '';
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          setOpenHeight(item);
        }
      });
    });

    // "View all FAQs" — reveal the hidden extras, then hide the button.
    var moreBtn = root.querySelector('[data-ftc-more]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        root.querySelectorAll('[data-ftc-extra]').forEach(function (el) {
          el.removeAttribute('hidden');
        });
        moreBtn.setAttribute('hidden', '');
      });
    }

    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        if (item.classList.contains('is-open')) setOpenHeight(item);
      });
    }, { passive: true });
  }

  document.querySelectorAll('[data-ftc-faq]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector) return;
    var r = e.target.querySelector('[data-ftc-faq]');
    if (r) init(r);
  });
})();
